export default __webpack_public_path__ + "static/media/online_etiquette.afc902e6.png";